export { ThemeContext, Theme } from './theme';
export type { ThemeProps } from './theme';

export { GfiTheme } from './theme.composition';
